// extracted by mini-css-extract-plugin
module.exports = {"loader-container":"loadingPage_loader-container__3hRjU","spinner":"loadingPage_spinner__2V3no","spin-anim":"loadingPage_spin-anim__ZmUcV"};